// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAlignLeftOutlinedSvg from "@fishx/icons-svg/es/asn/PAlignLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var PAlignLeftOutlined = function PAlignLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAlignLeftOutlinedSvg
  }));
};

PAlignLeftOutlined.displayName = 'PAlignLeftOutlined';
export default React.forwardRef(PAlignLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAlignLeftOutlined.js
// module id = 3204
// module chunks = 0